// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:14:27

export default {
  "id": "tiles-matching",
  "slug": "tiles-matching",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/7e02319e692c47b0b0eb47ba3f153f37-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/7e02319e692c47b0b0eb47ba3f153f37/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Tiles Matching",
      "description": "Free online game Tiles Matching - play in the browser without downloading. It is suitable for the development of logic for both adults and children - an ideal timekiller.\nTiles Matching is a puzzle game combining the game mechanics of Mahjong and Three in a Row (Match-3). A logical educational game for children and adults. With each level, the difficulty increases - not everyone can complete the game the first time. Challenge your intelligence.",
      "instructions": "Match 3 blocks of the same element so that they match each other. Match and remove all the tiles to complete the level. The game has a large number of levels that are becoming more difficult.",
      "genres": [
        "Mahjong & Connect",
        "Match-3"
      ],
      "tags": [
        "connection",
        "jewels",
        "logic",
        "match3",
        "sliding-puzzle"
      ]
    },
    "zh-CN": {
      "title": "瓷砖匹配",
      "description": "免费在线游戏瓷砖匹配 - 在浏览器中无需下载即可玩。适合成人和儿童逻辑能力的发展 - 理想的消磨时间游戏。\n瓷砖匹配是一款结合了麻将和三连珠（匹配3）游戏机制的益智游戏。适用于儿童和成人的逻辑教育游戏。每升一级，难度都会增加 - 并非每个人都能第一次就完成游戏。挑战你的智力。",
      "instructions": "将相同元素的3个方块匹配在一起。匹配并移除所有方块以完成关卡。游戏拥有大量关卡，难度逐渐提升。",
      "genres": [
        "麻将 & 连接",
        "三消匹配"
      ],
      "tags": [
        "连接",
        "宝石",
        "逻辑",
        "三消",
        "滑动拼图"
      ]
    },
    "zh-TW": {
      "title": "地塊匹配",
      "description": "免費在線遊戲拼圖配對 - 在瀏覽器中遊玩，無需下載。適合成人和兒童邏輯能力發展 - 理想的消磨時間選擇。\n拼圖配對是一款結合麻將和三子棋（配對3）遊戲機制的拼圖遊戲。適合兒童和成人邏輯教育遊戲。隨著每個關卡的進行，難度逐漸增加 - 不是所有人都能一次完成遊戲。挑戰你的智慧。",
      "instructions": "將相同元素的3塊方塊匹配起來，使其相互匹配。匹配並移除所有圖片以完成關卡。遊戲有大量關卡，難度逐漸提升。",
      "genres": [
        "麻將 & 連線",
        "三消遊戲"
      ],
      "tags": [
        "連線",
        "珠寶",
        "邏輯",
        "三消連線",
        "滑動拼圖"
      ]
    },
    "zh-HK": {
      "title": "瓦片配對",
      "description": "免費在線遊戲瓷砖匹配 - 在瀏覽器中遊玩，無需下載。適合成人及兒童邏輯發展 - 理想的消磨時間選擇。\n瓷砖匹配是一款結合麻將及三連珠（匹配3）遊戲機制的益智遊戲。適合兒童及成人邏輯教育遊戲。隨著每個關卡，難度逐漸提升 - 無法人人一試即過。挑戰你的智慧。",
      "instructions": "匹配三塊相同元素的方塊，使它們互相匹配。匹配並移除所有圖片，以完成關卡。遊戲有大量關卡，隨著進度會逐漸變得更具挑戰性。",
      "genres": [
        "麻將 & 連線",
        "三消配對"
      ],
      "tags": [
        "連線",
        "珠寶",
        "邏輯",
        "三消遊戲",
        "滑動拼圖"
      ]
    },
    "ja": {
      "title": "タイルマッチング",
      "description": "無料オンラインゲーム「タイルマッチング」- ブラウザでダウンロードなしでプレイ可能。大人も子供も逻辑能力の向上に適しており、理想的な暇つぶしのゲームです。\n\nタイルマッチングは、マージョンと三列並べ（マッチ3）のゲームメカニクスを組み合わせたパズルゲームです。子供も大人も楽しめる論理的な教育ゲームです。レベルごとに難度が上がるため、初めてゲームを終えるのは難しいかもしれません。あなたの知能に挑戦してください。",
      "instructions": "同じ要素のブロックを3つ連結させて一致させ、すべてのタイルを一致させてレベルをクリアします。ゲームには多くのレベルがあり、難易度が段階的に上がっています。",
      "genres": [
        "麻雀＆コネクト",
        "マッチ3"
      ],
      "tags": [
        "接続",
        "宝石",
        "論理",
        "マッチ3",
        "スライディングパズル"
      ]
    },
    "ko": {
      "title": "타일 매칭",
      "description": "자유 온라인 게임 타일 매칭 - 다운로드 없이 브라우저에서 플레이하세요. 성인과 어린이 모두의 논리력 개발에 적합합니다 - 완벽한 시간죽이기 게임입니다.\n타일 매칭은 마주봉합(Mahjong)과 세개 일치(Three in a Row, Match-3)의 게임 메커니즘을 결합한 패ズル 게임입니다. 어린이와 성인 모두를 위한 논리 교육 게임입니다. 각 레벨마다 난이도가 증가합니다 - 첫 번째로 게임을 완료할 수 있는 사람은 많지 않습니다. 지능을 도전하세요.",
      "instructions": "동일한 요소의 블록 3개를 맞추어 같게 만들어 블록을 모두 제거하여 레벨을 완료하세요. 게임에는 많은 수의 레벨이 있으며, 각 레벨이 점점 더 어려워집니다.",
      "genres": [
        "마작 & 커넥트",
        "매치-3"
      ],
      "tags": [
        "연결",
        "보석",
        "논리",
        "매치3",
        "슬라이딩 퍼즐"
      ]
    },
    "fr": {
      "title": "Fusion de tuiles",
      "description": "Jeux en ligne gratuits Tiles Matching - jouez dans le navigateur sans téléchargement. Il est adapté au développement de la logique pour les adultes et les enfants - un excellent moyen de passer le temps. Tiles Matching est un jeu de puzzle combinant les mécanismes de Mahjong et de Three in a Row (Match-3). Un jeu éducatif logique pour les enfants et les adultes. Avec chaque niveau, la difficulté augmente - tout le monde ne peut pas terminer le jeu au premier coup. Défiez votre intelligence.",
      "instructions": "Alignez 3 blocs du même élément pour qu'ils se correspondent. Allez les correspondre et enlever toutes les tuiles pour terminer le niveau. Le jeu comporte un grand nombre de niveaux qui deviennent de plus en plus difficiles.",
      "genres": [
        "Mahjong & Connect",
        "Jeu de correspondance à 3 alignés"
      ],
      "tags": [
        "connection",
        "bijoux",
        "logique",
        "match3",
        "puzzle glissant"
      ]
    }
  }
};
